import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { NbAuthJWTToken, NbAuthService } from '@nebular/auth';

@Component({
    selector: 'nb-dialog',
    template: `

  <!-- <nb-card style="width:1050px; height:750px;">
    <nb-card-header><a (click)="close()" ><i class="fa fa-window-close" style='float:right' ></i> </a>
            <nb-actions size="large" style="float: right;">
                <nb-action icon="nb-close"  (click)="close()"></nb-action>
            </nb-actions>
        </nb-card-header>
        <nb-card-body>
        <div *ngIf="imgType == 'docx' || imgType == 'DOCX'">
                <ngx-doc-viewer [url]="arr" viewer="google"   style="width:100%;height:93vh;">
                </ngx-doc-viewer>
            </div>

    </nb-card-body>
    </nb-card>

    <p-dialog [(visible)]="viewPdf" [modal]="true" [responsive]="true" [style]="{width: '1050px', height:'750px'}">
    <nb-card style="width:1050px; height:750px;">
      <nb-card-body>
         <embed id = 'viewimg' src="" frameborder="0" style="width:1050px; height:750px;">
      </nb-card-body>
    </nb-card>
    </p-dialog> -->

    <div class="container">
    <div class="container" mt=2>
    <embed id="viewimg" src="" style="width:800px; height:700px;">
    </div>
    </div>

    `,
})
export class previewImg implements OnInit{
    @Input() arr: any;
    @Input() imgType: any;

    auto;
    user_id;
    constructor(protected ref: NbDialogRef<previewImg>,
        private router: Router,
        private authService: NbAuthService,
        private toastrService: NbToastrService,
    ) {
        this.auto = 'auto';


        //   this.authService.onTokenChange()
        //     .subscribe((token: NbAuthJWTToken) => {
        //     this.user_id = token.getPayload()['id'];
        // });
        // <div ><img [src]="arr" height=":800px;" width="100%;" alt="Random first slide"></div>
    }
    ngOnInit() {
        this.viewPdf= true;
        // var img  = document.getElementById('viewpdf');
        // console.log("&&&&&&&&&&&&&&***********",this.arr);
        document.getElementById('viewimg').setAttribute("src", this.arr)

    }
    viewPdf:boolean;

    close() {
        this.ref.close();
    }






}